
import * as actionTypes from "../constants/actionTypes";

export interface SelectPropertyAction {
  type: "SELECT_PROPERTY";
  payload: {
    id: string;
    values: Array<string>;
  };
}

export type Action = SelectPropertyAction;

export function selectProperty(id: string, values: Array<string>): Action {
  return {
    type: actionTypes.SELECT_PROPERTY,
    payload: {
      id,
      values
    }
  };
}
